<template>
  <label :class="{ disabled }" class="Radio">
    <div class="form-input">
      <icon
        class="icon"
        :class="{ checked }"
        name="circle"
        :key="checked"
        :art="checked ? 'solid' : 'light'"
      />
      <input
        :checked="checked"
        :value="inputValue"
        :name="name"
        :disabled="disabled"
        type="radio"
        class="input"
        @change="$emit('input', inputValue)"
      />
    </div>
    <div>
      <slot />
    </div>
  </label>
</template>

<script>
import Icon from './Icon'

export default {
  name: 'Radio',

  components: {
    Icon,
  },

  props: {
    name: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number, Boolean],
      default: '',
    },

    inputValue: {
      type: [String, Number, Boolean],
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    checked() {
      return this.inputValue === this.value
    },

    color() {
      if (this.checked) {
        if (this.disabled) {
          return 'black'
        }
        return 'sanitas-green'
      }
      return 'black'
    },
  },
}
</script>

<style lang="postcss" scoped>
.Radio {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;

  &.disabled {
    cursor: not-allowed;
  }

  & > *,
  & >>> * {
    pointer-events: none;
  }

  .form-input {
    display: flex;
    width: 20px;
    margin-right: 2px;
    margin-top: 2px;
    padding: 3px;
  }

  .icon {
    font-size: 14px;
  }

  .icon.checked {
    color: #5bac26;
  }

  .input {
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;
  }
}
</style>
